// src/components/news/NewsCard.jsx
import { useTranslation } from "../../shared/LanguageContext";
import { BASE_URL } from "../../config";
import "./news.css";

export default function NewsCard({ item, onRead }) {
    const hasImage = item.images && item.images.length > 0;
    const hasVideo = !!item.videoUrl;
    const imgUrl = hasImage ? (item.images[0].startsWith('http') ? item.images[0] : `${BASE_URL}${item.images[0]}`) : null;
    const { language } = useTranslation();

    const currentTitle = item[`title_${language}`] || item.title;
    const currentLabel = item[`label_${language}`] || item.label;
    const currentHtml = item[`html_${language}`] || item.html || "";

    return (
        <article className="news-feature-card">
            <div className="news-feature-image">
                {imgUrl ? (
                    <img src={imgUrl} alt={currentTitle || "news"} />
                ) : hasVideo ? (
                    <div className="news-video-cover">
                        <div className="news-video-icon">▶</div>
                        <div className="news-video-text">Видео</div>
                    </div>
                ) : (
                    <div className="news-video-cover">
                        <div className="news-video-text">Нет обложки</div>
                    </div>
                )}
            </div>

            <div className="news-feature-content">
                {currentLabel && <span className="news-feature-label">{currentLabel}</span>}
                <h3>{currentTitle}</h3>
                <p
                    className="news-preview"
                    dangerouslySetInnerHTML={{
                        __html:
                            currentHtml.replace(/<[^>]+>/g, "").slice(0, 240) +
                            (currentHtml.replace(/<[^>]+>/g, "").length > 240 ? "…" : "")
                    }}
                />
                <div className="news-feature-actions">
                    <button className="news-feature-btn" onClick={() => onRead?.(item)}>
                        Читать статью
                    </button>
                </div>
            </div>
        </article>
    );
}
